export function deepMerge<T>(target: T, source: Partial<T>): T {
  const result = {...target} as T;
  const keys = Object.keys(source);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i] as keyof T;
    const value = source[key] as T[keyof T];
    if (typeof value === 'object' && typeof target[key] === 'object') {
      result[key] = deepMerge(target[key], value);
    } else {
      result[key] = value;
    }
  }
  return result;
}

export function hasOwnProperty<T>(obj: T, property: string): boolean {
  return Object.prototype.hasOwnProperty.call(obj, property);
}

export function toNumber(value: string) {
  const number = parseInt(value, 10);
  return isNaN(number) ? 0 : number;
}
